"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
const Node_1 = require("./Node");
const Rule_1 = require("./Rule");
const Transformation_1 = require("./Transformation");
const Command_1 = require("./Command");
class Visitor extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    constructor() {
        super(...arguments);
        this.visitNodeCtx = (tree) => this.visitTypeCtx(Node_1.default, tree);
        this.visitOperatorCtx = (tree) => this.visitTypeCtx(Node_1.Operator, tree);
    }
    constructOperator(symbol, childrenValues) {
        const children = childrenValues.map(value => this.visitNodeCtx(value));
        return new Node_1.Operator(symbol, children);
    }
    visitTypeCtx(type, tree) {
        const result = this.visit(tree);
        if (!(result instanceof type)) {
            throw Error(`Parsed tree should be of ${type.constructor.name} type`);
        }
        return result;
    }
    defaultResult() {
        return Node_1.FALSE;
    }
    visitNumber(ctx) {
        return new Node_1.Num(Number(ctx.NUMBER().text));
    }
    visitId(ctx) {
        return new Node_1.Symbol(ctx.ID().text);
    }
    visitRewritable(ctx) {
        return new Node_1.Rewritable(ctx.ID().text);
    }
    visitExprParens(ctx) {
        return this.visitNodeCtx(ctx.expr());
    }
    visitFunc(ctx) {
        return this.constructOperator(ctx.ID().text, immutable_1.List(ctx.expr()));
    }
    visitTrue(_) {
        return Node_1.TRUE;
    }
    visitFalse(_) {
        return Node_1.FALSE;
    }
    visitBooleanExprParens(ctx) {
        return this.visitNodeCtx(ctx.booleanExpr());
    }
    visitEquation(ctx) {
        return this.constructOperator(Node_1.OperatorSymbol.Equals, immutable_1.List(ctx.expr()));
    }
    visitBooleanExpr(ctx) {
        if (ctx._op === undefined) {
            return this.visitNodeCtx(ctx.booleanAtom(0));
        }
        return this.constructOperator(ctx._op.text, immutable_1.List(ctx.booleanAtom()));
    }
    visitAdditionExpr(ctx) {
        return this.constructOperator(ctx._op.text, immutable_1.List(ctx.expr()));
    }
    visitMultiplyingExpr(ctx) {
        return this.constructOperator(ctx._op.text, immutable_1.List(ctx.expr()));
    }
    visitPowExpr(ctx) {
        return this.constructOperator(Node_1.OperatorSymbol.Pow, immutable_1.List(ctx.expr()));
    }
    visitUnary(ctx) {
        return this.constructOperator(Node_1.OperatorSymbol.Minus, immutable_1.List([ctx.signedAtom()]));
    }
    visitRewriting(ctx) {
        const lhs = this.visitNodeCtx(ctx.expr(0));
        const rhs = this.visitNodeCtx(ctx.expr(1));
        const bexpCtx = ctx.booleanExpr();
        const condition = bexpCtx !== undefined ? this.visitNodeCtx(bexpCtx) : bexpCtx;
        return new Rule_1.default(lhs, rhs, condition);
    }
    visitCommand(ctx) {
        const params = immutable_1.List(ctx.ID().map(id => id.text));
        const cmd = ctx.COMMAND().text;
        return new Command_1.default(cmd, params);
    }
    visitTransformation(ctx) {
        return new Transformation_1.default(ctx.ID().text, immutable_1.List(ctx.rewriting().map(ruleCtx => this.visitTypeCtx(Rule_1.default, ruleCtx))));
    }
}
exports.default = Visitor;
//# sourceMappingURL=Visitor.js.map